import React from 'react';
import { Head } from '@keaze/web/components/head';
import { TermsOfUse } from '@keaze/web/views/termsOfUse';
import {GetStaticProps} from "next";
import CmsApi from "@keaze/web/utils/cmsApi";
import {RequestError} from "@keaze/web/common/interfaces";

type Props = {
    pageFields: Record<string, never>
};

const TermsOfUsePage = (props: Props) => {
  return (
    <>
      <Head
          withBaseSocialMetaTags
          title={props.pageFields.meta_title}
          description={props.pageFields.meta_description}
      >
      </Head>
      <TermsOfUse data={props.pageFields.elements['page-content']} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
    try {
        const [
            pageFields,
        ] = await Promise.all([
            CmsApi.getPageFieldsFromApi('terms_and_conditions')
        ]);

        return {
            revalidate: 60,
            props: {
                pageFields
            },
        };
    } catch (error) {
        const { message, notFound } = error as RequestError;

        if (notFound) {
            return {
                notFound: true,
            };
        }

        throw new Error(message);
    }
};

export default TermsOfUsePage;
